import { useEffect, useState } from 'react';
import { createVgsCollectForm } from '../services/vgs/collect/form';
import useVgsScripts from './useVgsScripts';

export default function useVgsCollect<ResponseData>():
  | VGSForm<ResponseData>
  | undefined {
  const [vgsCollectForm, setVgsCollectForm] = useState<VGSForm<ResponseData>>();
  const vgsScriptsLoaded = useVgsScripts();
  useEffect(() => {
    if (vgsCollectForm || !vgsScriptsLoaded) {
      return;
    }
    setVgsCollectForm(createVgsCollectForm());
  }, [vgsScriptsLoaded, vgsCollectForm]);
  return vgsCollectForm;
}
